// extracted by mini-css-extract-plugin
export default {"base":"vp_F85sL"};